import p1 from '../img/portImages/portfolio-1.jpg';

import p2 from '../img/portImages/portfolio-2.jpg';
import p3 from '../img/portImages/portfolio-3.jpg';
import p4 from '../img/portImages/portfolio-4.jpg';
import p5 from '../img/portImages/portfolio-5.jpg';
import p6 from '../img/portImages/portfolio-6.jpg';

const portfolios = [
    {
        id: 1,
        image: p1,
        link: 'https://youtu.be/qL1en3gs5rk',
        link1: 'https://github.com/prabhukumarsaw/Basic-Banking-System',
        title: 'Basic Bank System'
    },
    
   
    {
        id: 2,
        image: p2,
        link: 'https://youtu.be/qL1en3gs5rk',
        link1: 'https://github.com/prabhukumarsaw/Basic-Banking-System',
        title: 'Basic Bank System'
    },
    {
        id: 3,
        image: p3,
        link: 'https://youtu.be/qL1en3gs5rk',
        link1: 'https://github.com/prabhukumarsaw/Basic-Banking-System',
        title: 'Basic Bank System'
        
    },
    {
        id: 4,
        image: p4,
        link: 'https://youtu.be/qL1en3gs5rk',
        link1: 'https://github.com/prabhukumarsaw/Basic-Banking-System',
        title: 'Basic Bank System'
    },
    {
        id: 5,
        image: p5,
        link: 'https://youtu.be/qL1en3gs5rk',
        link1: 'https://github.com/prabhukumarsaw/Basic-Banking-System',
        title: 'Basic Bank System'
    },
    {
        id: 6,
        image: p6,
        link: 'https://youtu.be/qL1en3gs5rk',
        link1: 'https://github.com/prabhukumarsaw/Basic-Banking-System',
        title: 'Basic Bank System'
    },
   
]

export default portfolios;